// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"185":"9265a866","214":"073059f3","520":"88c42fd7","649":"6532ad28"}[chunkId] + ".chunk.js";
};